import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';
import { Button } from '../ui/button';

export function ThemeToggle({ variant = 'icon', className = '' }) {
  var themeContext = useTheme();
  var theme = themeContext.theme;
  var toggleTheme = themeContext.toggleTheme;

  if (variant === 'icon') {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleTheme}
        className={'h-9 w-9 p-0 ' + className}
        title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        data-testid="theme-toggle"
      >
        {theme === 'dark' ? (
          <Sun className="h-4 w-4 text-slate-400 hover:text-white transition-colors" />
        ) : (
          <Moon className="h-4 w-4 text-slate-500 hover:text-slate-700 transition-colors" />
        )}
      </Button>
    );
  }

  // Full button variant for settings
  return (
    <div className={'flex items-center gap-3 ' + className}>
      <span className="text-sm text-slate-400">Theme</span>
      <div className="flex items-center gap-1 p-1 rounded-lg bg-slate-800/60 border border-slate-700">
        <button
          onClick={function() { themeContext.setTheme('light'); }}
          className={'flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ' +
            (theme === 'light' 
              ? 'bg-white text-slate-900 shadow-sm' 
              : 'text-slate-400 hover:text-white')}
          data-testid="theme-light-btn"
        >
          <Sun className="h-4 w-4" />
          Light
        </button>
        <button
          onClick={function() { themeContext.setTheme('dark'); }}
          className={'flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ' +
            (theme === 'dark' 
              ? 'bg-slate-700 text-white shadow-sm' 
              : 'text-slate-400 hover:text-white')}
          data-testid="theme-dark-btn"
        >
          <Moon className="h-4 w-4" />
          Dark
        </button>
      </div>
    </div>
  );
}

export default ThemeToggle;
